import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import TooltipIconButton from "components/TooltipIconButton";
import { StoreOutlined, DirectionsWalkOutlined, PanoramaPhotosphereOutlined, MapOutlined, AddOutlined } from '@mui/icons-material';

const CaptureButtons = (props) => {
    const dispatch = useDispatch();
    const cityScanActive = useSelector(state => state.settings.cityScanActive);
    const streetScanActive = useSelector(state => state.settings.streetScanActive);
    const siteScanActive = useSelector(state => state.settings.siteScanActive);

    const onCityScan = () => {
        dispatch({ type: 'SET_STREET_SCAN_ACTIVE', streetScanActive: false });
        dispatch({ type: 'SET_SITE_SCAN_ACTIVE', siteScanActive: false });
        dispatch({ type: 'SET_CITY_SCAN_ACTIVE', cityScanActive: !cityScanActive });
    }

    const onStreetScan = () => {
        dispatch({ type: 'SET_CITY_SCAN_ACTIVE', cityScanActive: false });
        dispatch({ type: 'SET_SITE_SCAN_ACTIVE', siteScanActive: false });
        dispatch({ type: 'SET_STREET_SCAN_ACTIVE', streetScanActive: !streetScanActive });
    }

    const onSiteScan = () => {
        dispatch({ type: 'SET_CITY_SCAN_ACTIVE', cityScanActive: false });
        dispatch({ type: 'SET_STREET_SCAN_ACTIVE', streetScanActive: false });
        dispatch({ type: 'SET_SITE_SCAN_ACTIVE', siteScanActive: !siteScanActive });
    }

    return (
        <div style={{ paddingTop: '1.5rem', paddingBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', width: '300px' }}>
            <TooltipIconButton title="City Scan" ariaLabel="City Scan" border={true} onClick={onCityScan} toggle={cityScanActive}>
                <MapOutlined />
            </TooltipIconButton>
            <TooltipIconButton title="Street Scan" ariaLabel="Street Scan" border={true} onClick={onStreetScan} toggle={streetScanActive}>
                <PanoramaPhotosphereOutlined />
            </TooltipIconButton>
            <TooltipIconButton title="Site Scan" ariaLabel="Site Scan" border={true} onClick={onSiteScan} toggle={siteScanActive}>
                <DirectionsWalkOutlined />
            </TooltipIconButton>
            <TooltipIconButton title="Marketplace" ariaLabel="Marketplace" border={true} onClick={props.onMarketPlace}>
                <StoreOutlined />
            </TooltipIconButton>
            <TooltipIconButton title="Add Assets" ariaLabel="Add Assets" border={true} onClick={props.onAddAssets}>
                <AddOutlined />
            </TooltipIconButton>
        </div>
    )
}

export default CaptureButtons;